// @ts-nocheck
/* eslint-disable */
export const boldMinusIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M10.793 1.339H5.207c-2.427 0-3.874 1.447-3.874 3.873v5.58c0 2.434 1.447 3.88 3.874 3.88h5.58c2.426 0 3.873-1.447 3.873-3.873V5.212c.007-2.426-1.44-3.873-3.867-3.873M12 8.506H4a.504.504 0 0 1-.5-.5c0-.274.227-.5.5-.5h8c.273 0 .5.226.5.5 0 .273-.227.5-.5.5"/></svg>`,
    name: 'bold-minus' as const
};